(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-main-article"]) return;
  try {
    
  (function () {
    var FAQ_HEADING = /faq|frequently asked questions/i;
    var TAKEAWAYS = /key takeaways/i;

    function headingLevel(el) {
      return el && /^H[1-6]$/.test(el.tagName) ? parseInt(el.tagName.charAt(1), 10) : 99;
    }

    function headingText(el) {
      return ((el && el.textContent) || '').trim();
    }

    function isSpecialHeading(el) {
      var text = headingText(el);
      return FAQ_HEADING.test(text) || TAKEAWAYS.test(text);
    }

    function slugify(text) {
      var slug = (text || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 80);
      return slug || 'section';
    }

    function isQuestionNode(el) {
      if (!el) return false;
      var text = headingText(el);
      if (/^H[3-6]$/.test(el.tagName)) return true;
      if (el.tagName === 'H2') return /\?\s*$/.test(text);
      if (el.tagName !== 'P') return false;
      if (!text || !/\?\s*$/.test(text)) return false;
      return text.length < 180 || !!el.querySelector('strong, b');
    }

    function enhanceTakeaways(root) {
      if (!root || root.querySelector('.hello-article-takeaways')) return;
      var heading = Array.prototype.find.call(root.querySelectorAll('h2, h3'), function (el) {
        return TAKEAWAYS.test(headingText(el));
      });
      if (!heading) return;
      var list = heading.nextElementSibling;
      if (!list || (list.tagName !== 'UL' && list.tagName !== 'OL')) return;
      var wrap = document.createElement('aside');
      wrap.className = 'hello-article-takeaways';
      wrap.setAttribute('aria-label', headingText(heading));
      heading.parentNode.insertBefore(wrap, heading);
      wrap.appendChild(heading);
      wrap.appendChild(list);
    }

    function enhanceLead(root) {
      if (!root || root.querySelector('.hello-article-lead')) return;
      var child;
      for (var i = 0; i < root.children.length; i += 1) {
        child = root.children[i];
        if (child.classList.contains('hello-article-takeaways')) continue;
        if (child.tagName === 'P') {
          child.classList.add('hello-article-lead');
          return;
        }
        if (/^H[1-6]$/.test(child.tagName)) return;
      }
    }

    function enhanceSteps(root) {
      Array.prototype.forEach.call(root.querySelectorAll('ol'), function (ol) {
        if (ol.closest('.hello-article-takeaways, .hello-article-faq, .hello-article-checklist')) return;
        if (ol.children.length < 2) return;
        ol.classList.add('hello-article-steps');
        var prev = ol.previousElementSibling;
        while (prev && prev.tagName === 'P') prev = prev.previousElementSibling;
        if (prev && /^H[1-6]$/.test(prev.tagName) && /5 steps/i.test(prev.textContent || '')) {
          ol.classList.add('hello-article-flow');
        }
      });
    }

    function noteKind(text) {
      var t = (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t.indexOf('pro tip') === 0) return 'tip';
      if (t.indexOf("don't do this") === 0 || t.indexOf('do not do this') === 0) return 'dont';
      if (t.indexOf('good to know') === 0) return 'know';
      if (t.indexOf('how hello mrs makes this easier') === 0) return 'kit';
      return '';
    }

    function enhanceNotes(root) {
      Array.prototype.forEach.call(root.querySelectorAll('blockquote'), function (quote) {
        if (quote.classList.contains('hello-article-note')) return;
        var kind = noteKind(quote.textContent);
        if (!kind) return;
        quote.classList.add('hello-article-note', 'hello-article-note--' + kind);
      });
    }

    function enhanceHeadings(root) {
      var used = {};
      Array.prototype.forEach.call(root.querySelectorAll('h2'), function (h2) {
        if (isSpecialHeading(h2)) return;
        if (h2.closest('.hello-article-takeaways, .hello-article-faq, .hello-article-checklist')) return;
        var id = h2.id || slugify(headingText(h2));
        var base = id;
        var n = 2;
        while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h2)) {
          id = base + '-' + n;
          n += 1;
        }
        h2.id = id;
        used[id] = true;
      });
    }

    function contentHeadings(root) {
      return Array.prototype.filter.call(root.querySelectorAll('h2'), function (h2) {
        if (!h2.id) return false;
        if (h2.closest('.hello-article-takeaways, .hello-article-faq, .hello-article-checklist')) return false;
        return !isSpecialHeading(h2);
      });
    }

    function buildToc(articleRoot, contentRoot) {
      var lists = articleRoot.querySelectorAll('[data-hello-article-toc]');
      if (!lists.length) return;
      var headings = contentHeadings(contentRoot);
      var navs = articleRoot.querySelectorAll('.hello-article-toc');
      if (headings.length < 3) {
        Array.prototype.forEach.call(navs, function (nav) {
          nav.hidden = true;
        });
        return;
      }
      Array.prototype.forEach.call(navs, function (nav) {
        nav.hidden = false;
      });
      Array.prototype.forEach.call(lists, function (list) {
        list.innerHTML = '';
        headings.forEach(function (h2) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h2.id;
          a.textContent = headingText(h2);
          li.appendChild(a);
          list.appendChild(li);
        });
      });
    }

    function injectKitCta(articleRoot, contentRoot) {
      if (window.location.pathname.indexOf('how-to-change-last-name-after-marriage') !== -1) return;
      var source = articleRoot.querySelector('[data-hello-kit-cta]');
      if (!source || contentRoot.querySelector('.hello-article-kit--inline')) return;
      var h2s = contentHeadings(contentRoot);
      if (h2s.length < 2) return;
      var clone = source.cloneNode(true);
      clone.removeAttribute('data-hello-kit-cta');
      clone.classList.add('hello-article-kit--inline');
      h2s[1].parentNode.insertBefore(clone, h2s[1]);
    }

    function enhanceFaq(root) {
      if (!root || root.querySelector('.hello-article-faq')) return;

      var heading = Array.prototype.find.call(root.querySelectorAll('h2, h3'), function (el) {
        return FAQ_HEADING.test(headingText(el));
      });
      if (!heading) return;

      var faqLevel = headingLevel(heading);
      var nodes = [];
      var node = heading.nextElementSibling;
      while (node) {
        var level = headingLevel(node);
        if (level < faqLevel) break;
        if (level === faqLevel && !isQuestionNode(node)) break;
        nodes.push(node);
        node = node.nextElementSibling;
      }
      if (!nodes.length) return;

      var pairs = [];
      var current = null;
      nodes.forEach(function (el) {
        if (el.tagName === 'DETAILS') {
          current = null;
          return;
        }
        if (isQuestionNode(el)) {
          current = { question: el, answers: [] };
          pairs.push(current);
          return;
        }
        if (current) current.answers.push(el);
      });
      pairs = pairs.filter(function (pair) {
        return pair.answers.length > 0;
      });
      if (!pairs.length) return;

      var wrap = document.createElement('div');
      wrap.className = 'hello-article-faq';

      pairs.forEach(function (pair) {
        var item = document.createElement('details');
        item.className = 'hello-article-faq__item';

        var summary = document.createElement('summary');
        summary.className = 'hello-article-faq__summary';

        var kicker = document.createElement('span');
        kicker.className = 'hello-article-faq__q';
        kicker.setAttribute('aria-hidden', 'true');
        kicker.textContent = 'Q';

        var question = document.createElement('span');
        question.className = 'hello-article-faq__question';
        question.textContent = headingText(pair.question);

        var toggle = document.createElement('span');
        toggle.className = 'hello-article-faq__toggle';
        toggle.setAttribute('aria-hidden', 'true');
        toggle.textContent = '+';

        summary.appendChild(kicker);
        summary.appendChild(question);
        summary.appendChild(toggle);
        item.appendChild(summary);

        var answer = document.createElement('div');
        answer.className = 'hello-article-faq__answer';
        pair.answers.forEach(function (child) {
          answer.appendChild(child);
        });
        item.appendChild(answer);
        wrap.appendChild(item);

        if (pair.question.parentNode) pair.question.remove();
      });

      heading.after(wrap);
    }

    function enhanceArticle(articleRoot) {
      var root = articleRoot.querySelector('.hello-main-article__content');
      if (!root) return;
      enhanceTakeaways(root);
      enhanceLead(root);
      enhanceNotes(root);
      enhanceHeadings(root);
      enhanceFaq(root);
      buildToc(articleRoot, root);
    }

    function run(scope) {
      var articles = (scope || document).querySelectorAll('.hello-main-article');
      Array.prototype.forEach.call(articles, enhanceArticle);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        run(document);
      });
    } else {
      run(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      run(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
